import React from "react";

/**
 * 사용자가 쓴 글 안의 주소를 누를 수 있게 만든다.
 *
 * dangerouslySetInnerHTML 을 쓰지 않는다. 남이 쓴 글을 HTML 로 넣으면
 * 스크립트가 함께 들어온다. 조각으로 잘라 React 가 이스케이프하게 둔다.
 *
 * 스킴도 http / https 만 받는다. new URL 은 javascript:alert(1) 도
 * 통과시키므로 protocol 을 직접 본다 — 그대로 href 에 넣으면 누르는
 * 순간 그 글을 쓴 사람의 코드가 실행된다.
 */

/** http(s):// 로 시작하거나 www. 로 시작하는 덩어리 */
const URL_RE = /(https?:\/\/[^\s<>"'()]+|www\.[^\s<>"'()]+)/gi;

/** 문장 끝에 붙은 문장부호는 주소가 아니다: "muroo.kr 을 봐." */
const TRAILING = /[.,!?;:"'”’」』)\]]+$/;

function toHref(raw) {
  const url = raw.startsWith("www.") ? `https://${raw}` : raw;
  try {
    const u = new URL(url);
    if (u.protocol !== "http:" && u.protocol !== "https:") return null;
    return u.href;
  } catch {
    return null;
  }
}

export default function Linkify({ text }) {
  const src = String(text ?? "");
  const out = [];
  let last = 0;

  for (const m of src.matchAll(URL_RE)) {
    const trail = (m[0].match(TRAILING) || [""])[0];
    const raw = trail ? m[0].slice(0, -trail.length) : m[0];
    const href = toHref(raw);

    if (m.index > last) out.push(src.slice(last, m.index));
    if (href) {
      out.push(
        <a
          key={m.index}
          className="linkified"
          href={href}
          target="_blank"
          // noreferrer 까지 둔다. 새 창이 이 페이지를 조작하지 못하게 한다.
          rel="noopener noreferrer nofollow ugc"
          onClick={(e) => e.stopPropagation()}
        >
          {raw}
        </a>
      );
    } else {
      // 주소가 아니면 글자 그대로 둔다. 조용히 지우지 않는다.
      out.push(raw);
    }
    if (trail) out.push(trail);
    last = m.index + m[0].length;
  }
  if (last < src.length) out.push(src.slice(last));

  return <>{out}</>;
}
